import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import * as Types from '../../../types';
import { toast } from 'sonner';
import SEO from '@components/seo';

export default function User() {
  const { id } = useParams();
  const [user, setUser] = useState<Types.User>();
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/user/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    }).then(response => {
        setUser(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setUser((prev) => {
      if (!prev) return prev;

      const keys = name.split('[').map((key: any) => key.replace(']', ''));

      if (keys.length === 1) {
        return {
          ...prev,
          [keys[0]]: value,
        };
      }

      if (keys.length === 2) {
        return {
          ...prev,
          [keys[0]]: {
            ...prev[keys[0] as keyof typeof prev],
            [keys[1]]: value,
          },
        };
      }

      return prev;
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/user/${id}`, user, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
    })
    .then(_ => {
      toast.success('Информация обновлена')
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка');
    });
  };

  const handleSendMessage = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/user/${id}/sendMessage`, { message: message }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(_ => {
      toast.success('Сообщение отправлено')
      setMessage('');
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка отправки сообщения');
    });
  };

  return (
    <Content>
      <SEO 
        title={'Управление пользователем'}
        description={'Админ-панель'}
        ogUrl={`https://рыбныимир.рф`}
      />

      <h1 className={css.head}>{user?.phone}</h1>
      <form onSubmit={handleSubmit}>
        <b className={css.headAcc}>Личные данные</b>

        <div className={css.inputGrid}>
          <label>Имя</label>
          <input name='firstName' type='text' placeholder='Имя' value={user?.firstName} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Фамилия</label>
          <input name='lastName' type='text' placeholder='Фамилия' value={user?.lastName} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Логин</label>
          <input name='username' type='text' placeholder='Логин' value={user?.username} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Номер телефона (Менять нельзя)</label>
          <input name='phone' type='text' placeholder='Номер телефона' value={user?.phone} onChange={handleChange} required readOnly/>
        </div>

        <div className={css.inputGrid}>
          <label>Уровень доступа</label>
          <select name='access' value={user?.access} onChange={handleChange}>
              <option value={1}>Администратор</option>
              <option value={0}>Пользователь</option>
          </select>
        </div>

        <b className={css.headAcc}>Данные компании</b>

        <div className={css.inputGrid}>
          <label>Статус организации</label>
          <a style={{ flex: 3.05 }}>{user?.information?.status === 'ACTIVE' ? <span style={{ color: 'green' }}>Действующая</span> : <span style={{ color: 'red' }}>Ликвидирована</span>}</a>
        </div>

        <div className={css.inputGrid}>
          <label>Наименование организации</label>
          <input name='information[name]' type='text' placeholder='Наименование организации' value={user?.information?.name} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>ИНН</label>
          <input name='information[inn]' type='text' placeholder='ИНН' value={user?.information?.inn} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>ОГРН</label>
          <input name='information[ogrn]' type='text' placeholder='ОГРН' value={user?.information?.ogrn} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Адрес организации</label>
          <input name='information[address]' type='text' placeholder='Адрес организации' value={user?.information?.address} onChange={handleChange} />
        </div>

        <b className={css.headAcc}>Административные данные</b>

        <div className={css.inputGrid}>
          <label>Комментарий администратора</label>
          <textarea name='adminComment' placeholder='Заметки' style={{ height: 100 }} onChange={handleChange} value={user?.adminComment} />
        </div>

        <div className={css.inputGrid}>
          <label>Дата создания аккаунта</label>
          <a style={{ flex: 3.05 }}>{new Date(user?.createdAt || '').toLocaleDateString() || 'Не указано'}</a>
        </div>
        
        <div className={css.inputGrid}>
          <label>Дата последнего обновления аккаунта</label>
          <a style={{ flex: 3.05 }}>{new Date(user?.updatedAt || '').toLocaleDateString() || 'Не указано'}</a>
        </div>
        
        <button className={css.saveBtn} type='submit'>Сохранить изменения</button>

        <div className={css.sendMessageContainer}>
          <b>Отправить сообщение и начать чат</b>
          <textarea name='message' placeholder='Сообщение' value={message} onChange={(e) => setMessage(e.target.value)} />
          <button className={css.sendMessageBtn} type='button' onClick={handleSendMessage}>Отправить сообщение</button>
        </div>
      </form>
    </Content>
  );
}
